import { style } from "@vanilla-extract/css";

export const amenityCardStyle = style({});

export const cardTitleStyle = style({
  lineHeight: 1.15,
});

export const cardSubtitleStyle = style({
  lineHeight: 1.2,
});

export const cardContentStyle = style({
  alignItems: "flex-start",
});
